


















































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import TransactionsOptions from "@/models/Accounts/Shared/Transactions/TransactionsOptions";

@Component({ name: 'WalletsTransactionRichDataDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    dialog = false;

    @Prop({ required: true })
    transactionId: string;

    @Prop({ required: true })
    transactionsSelection: string;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            if (this.transactionsSelection === TransactionsOptions.Cleared) {
                await DepositAccountModule.getWalletTransactionRichData(this.transactionId);
            }
            else {
                await DepositAccountModule.getWalletPendingTransactionRichData(this.transactionId);
            }
        }
    }

    get transaction() {
        return DepositAccountModule.currentDepositAccountWalletTransactionRichData;
    }

    get loading() {
        return DepositAccountModule.loadingTransactions;
    }
}
